export default "__VITE_ASSET__BpK6Y$N3__"